export default {
  name: 'header-panel',
  props: {},
};
